import { ApplicationConfig, importProvidersFrom, isDevMode } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthInterceptor } from './core/auth/interceptors/auth.interceptor';
import { environment } from 'src/environments/environment';
import { RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha-2';
import { provideServiceWorker } from '@angular/service-worker';
import { MawAuthModule } from '@medappsware/maw-auth';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
        routes,
        withInMemoryScrolling({
            scrollPositionRestoration: "top",
        })
    ),
    provideHttpClient(withInterceptorsFromDi()),
    {
        provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true
    },
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptchaKey },
    provideServiceWorker('ngsw-worker.js', {
        enabled: !isDevMode(),
        registrationStrategy: 'registerWhenStable:30000'
    }),
    importProvidersFrom([
        MawAuthModule.forRoot({firebase: environment.firebase})
    ]) 
    ]
};
